const colors: ColorProps = {
  white: '#fff',
  black: '#000',
  offWhite: '#FDFDFD',
  primary: '#192543',
  primary800: '#1F2E53',
  primary700: '#253764',
  primary600: '#49587E',
  primary500: '#6D7997',
  primary400: '#929BB1',
  primary300: '#B6BCCB',
  primary200: '#DADDE5',
  primary100: '#ECEEF3',
  secondary: '#501B04',
  secondary800: '#7A2905',
  secondary700: '#CC4409',
  secondary600: '#F5520B',
  secondary500: '#F76F34',
  secondary400: '#F88C5D',
  secondary300: '#FAA986',
  secondary200: '#FCC6AF',
  secondary100: '#FFD9CC',
  tertiary: '#501B04',
  tertiary800: '#7A2905',
  tertiary700: '#CC4409',
  tertiary600: '#F5520B',
  tertiary500: '#F76F34',
  tertiary400: '#F88C5D',
  tertiary300: '#FAA986',
  tertiary200: '#FCC6AF',
  tertiary100: '#FFD9CC',
  purple800: '#5F013D',
  purple700: '#813160',
  purple600: '#914772',
  purple500: '#A25F85',
  purple400: '#B27798',
  purple300: '#C291AC',
  purple200: '#D2ABC0',
  purple100: '#E1C6D5',
  blue900: '#0D2844',
  blue800: '#69ACDF',
  blue700: '#8DBCE6',
  blue600: '#9EC4E9',
  blue500: '#ADCCED',
  blue400: '#BCD4F0',
  blue300: '#CADDF3',
  blue200: '#D8E5F6',
  blue100: '#E5EEFA',
  blueNichtverschwenden: '#0c0098',
  blueNichtverschwenden2: '#1748FD',
  blueNichtverschwendenLight: '#019AEE',
  nightBlue100: '#DFE4E9',
  nightBlue300: '#9BABBB',
  nightBlue400: '#788EA4',
  nightBlue500: '#56718D',
  nightBlue700: '#12385F',
  nightBlue900: '#0D2844',
  green800: '#72942D',
  green700: '#8EA855',
  green600: '#9CB269',
  green500: '#AABD7D',
  green400: '#B8C892',
  green300: '#C6D2A7',
  green200: '#D4DDBC',
  green100: '#E2E8D2',
  greenLight: '#F5F6EB',
  grey900: '#232323',
  grey800: '#3B3B3B',
  grey700: '#595959',
  grey600: '#848484',
  grey500: '#B0B0B0',
  grey400: '#D6D6D6',
  grey300: '#E9E9E9',
  grey200: '#F2F2F2',
  grey100: '#FAFAFA',
  grue: '#1A202C',
  grue800: '#2D3748',
  grue700: '#4A5568',
  grue600: '#718096',
  grue500: '#A0AEC0',
  grue400: '#CBD5E0',
  grue300: '#E2E8F0',
  grue200: '#EDF2F7',
  grue100: '#F7FAFC',
  primaryLightOrange700: '#C24C0A',
  orange: '#EA5B0C',
  orangeLight: '#FDEFE7',
  error: '#E53E3E', // red600
  errorBg: '#742A2A',
  success: '#9AE6B4',
  successBg: '#22543D',
  warning: '#FEEBC8',
  warningBg: '#7B341E',
  primarySunYellow100: '#FFEACD',
  primarySunYellow300: '#FFD59C',
  primarySunYellow700: '#FFAD38',
  primarySunYellow800: '#FF9A00',
  secondarySoftPurple200: '#D2ABC0',
  secondarySoftPurple400: '#B27798',
  secondarySoftPurple600: '#914772',
  secondarySoftPurple800: '#5F013D',
  secondarySoftPurple900: '#45002C',
};

export interface ColorProps {
  [key: string]: string;
}

export default colors;
